<template>
    <div class="page" style="padding:12px">
        <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
          <el-button size="medium" type="primary" v-if="!isAlreadyUpgarde" @click="upgradeFunc">
                {{!upGradeStatus || upGradeStatus == 0 ? '开始升年级' : '继续升年级'}}
            </el-button>
        </div>
        <div class="body"  :style="`height: ${windowHeight-180}px;`">
           <div class="content">
            <h2>{{schoolName}}</h2>
            <div class="hint">
                <div class="hint-item">1、请认真检查<span class="extra-hint">年级和学年</span>是否对应，今年毕业年级的入学年份应该为：<span
                    class="extra-hint">{{graduateYear}}级</span>！
                </div>
                <div class="hint-item">2、请选择<span class="extra-hint">正确的毕业年级</span>，选错则无法正常执行（混合制可能需要手动调整）。</div>
                <div class="hint-item">3、如果需要<span class="extra-hint">直升</span>，请勾选毕业年级后面的按钮。</div>
                <div class="hint-item">4、请选择是否保留相关数据（建议勾选，一般学校都不需要保留家长账号）。</div>
            </div>
            <div class="school-info">
                <div class="school-info-item">
                    学校类型：&nbsp;&nbsp;{{parseToConstants(schoolType, 'schoolTypeConstants')}}
                </div>
                <div class="school-info-item">
                    升级阶段：&nbsp;&nbsp;{{['尚未做升级！', '已升过年级！', '毕业年级已处理！', '升级年级已处理！'][upGradeStatus]}}
                </div>
            </div>
            <div class="grade-setting">
                <el-table
                    :data="gradeList"
                    style="width: 100%"
                >
                    <el-table-column
                        align="center"
                        label="需要毕业请勾选"
                        width="100"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                v-model="upGradeIds"
                                :label="scope.row.id"
                                @change="upGradeChange(scope.row.id)"
                                v-if="scope.row.canGraduate">&nbsp;</el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="学校名称"
                        align="center"
                    >
                        <template slot-scope="scope">
                         <span>
                             年级：{{scope.row.name}}，入学年份：{{scope.row.learnYear}}级，编码：{{scope.row.code}}
                         </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="需要直升请勾选"
                        width="100"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                @change="continueUpGradeChange(scope.row.id)"
                                v-model="continueUpGradeIds"
                                :label="scope.row.id"
                                v-if="scope.row.canContinueUpgrade">&nbsp;</el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="clear-setting" v-if="!isAlreadyUpgarde">
                毕业年级数据：<el-checkbox v-model="clearParent">清除毕业学生的家长账号</el-checkbox>
            </div>
        </div>
        </div>
        
        <el-dialog title="提示" :visible.sync="isShowDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <div>学校类型：{{parseToConstants(schoolType, 'schoolTypeConstants')}}</div>
                <div>选择的毕业年级：{{upGradeNames || '无'}}</div>
                <div>需要直升的毕业年级：{{continueUpGradeNames || '无'}}</div>
                <div>是否保留家长数据：{{clearParent ? '不保留' : '保留'}}</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="upgradeConfirmFunc()">确定</el-button>
            </span>
        </el-dialog>

         <el-dialog title="升年级返回信息" :visible.sync="newisShowDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <div v-html="newhtml"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="newisShowDialogfun()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    import moment from 'moment';
    import {parseToConstants} from '@/utils/utils';

    import {
        upgrade,
        queryGradeList,
        queryAlreadyUpgarde,
        queryCanContinueUpgrade
    } from '@/api/schoolManage';
    import mixin from "@/mixins/windowResize";
    import BackTool from '@/components/BackTool';

    function getGraduateYear(type) {
        let graduateYear = '';
        const yearsKind = 3; // 幼儿园
        const yearsPri = 6; // 小学
        const yearsMin = 3; // 初中
        const yearsHig = 3; // 高中
        const nowYear = moment().year();
        switch (type) {
            case '1':
                // 幼儿园三年，托班特殊考虑
                graduateYear += `${nowYear - yearsKind}`;
                break;
            case '2':
                // 小学六年
                graduateYear += `${nowYear - yearsPri}`;
                break;
            case '3':

                // 初中三年
                graduateYear += `${nowYear - yearsMin}`;
                break;
            case '4':
                // 高中三年
                graduateYear += `${nowYear - yearsHig}`;
                break;
            case '9':
                // 九年制：小学、初中
                graduateYear += `${nowYear - yearsPri}`;
                graduateYear += `,${nowYear - yearsMin}`;
                break;
            case '6':
                // 六年制：初中、高中

                graduateYear += `${nowYear - yearsMin}`;
                graduateYear += `,${nowYear - yearsHig}`;
                break;
            case '12':
                // 十二年制：小学、初中、高中
                graduateYear += `${nowYear - yearsPri}`;
                graduateYear += `,${nowYear - yearsMin}`;
                graduateYear += `,${nowYear - yearsHig}`;
                break;
            default:
                break;
        }
        return graduateYear;
    }
    
    export default {
        name: 'promoteGrade',
        data() {
            return {
                isShowDialog: false,
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                schoolType: this.$route.query.schoolType,
                upGradeStatus: this.$route.query.upGradeStatus,
                graduateYear: '',
                gradeList: [],
                canContinueUpgrade: false,
                isAlreadyUpgarde: true,
                continueUpGradeIds: [],
                upGradeIds: [],
                continueUpGradeNames: '',
                upGradeNames: '',
                clearParent: true,
                newisShowDialog:false,
                newhtml:""
            }
        },
        components: {BackTool},
        mixins: [mixin],
        created() {
            this.graduateYear = getGraduateYear(this.schoolType);
            this.initData();
        },
        methods: {
            parseToConstants,
            initData() {
                queryGradeList({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.gradeList = data;
                    });
                // queryCanContinueUpgrade({
                //     schoolId: this.schoolId
                // })
                //     .then(data => {
                //         this.canContinueUpgrade = data.canContinueUpgrade;
                //     });
                queryAlreadyUpgarde({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.isAlreadyUpgarde = false;
                    });
            },
            upGradeChange(id) {
                if(this.upGradeIds.findIndex(item => item.id == id) !== -1) {
                    const index = this.continueUpGradeIds.findIndex(item => item.id == id);
                    if(index !== -1) {
                        this.continueUpGradeIds.splice(index, 1);
                    }
                }
            },
            continueUpGradeChange(id) {
                if(this.continueUpGradeIds.findIndex(item => item.id == id) !== -1) {
                    const index = this.upGradeIds.findIndex(item => item.id == id);
                    if(index !== -1) {
                        this.upGradeIds.splice(index, 1);
                    }
                }
            },
            upgradeFunc() {
                const continueUpGradeNames = [], upGradeNames = [];
                this.gradeList.forEach(item => {
                    if(this.continueUpGradeIds.findIndex(id => item.id == id) !== -1) {
                        continueUpGradeNames.push(item.name);
                    }
                    if(this.upGradeIds.findIndex(id => item.id == id) !== -1) {
                        upGradeNames.push(item.name);
                    }
                });
                this.continueUpGradeNames = continueUpGradeNames.join(', ');
                this.upGradeNames = upGradeNames.join(', ');
                this.isShowDialog = true;
            },
            upgradeConfirmFunc() {
                upgrade({
                    clearParent: this.clearParent,
                    // clearStudent: false,
                    continueUpGradeIds: this.continueUpGradeIds.join(','),
                    upGradeIds: this.upGradeIds.join(','),
                    schoolId: this.schoolId
                })
                    .then((res) => {
                        this.isShowDialog = false;
                        this.newisShowDialog=true;
                        this.newhtml=res;
                        // this.$message.success('升年级完成');
                        // this.initData();
                    })
            },
            newisShowDialogfun(){
                this.newisShowDialog=false;
                this.initData();
            }
        }
    }
</script>

<style lang="scss" scoped>
.top{
     border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
}
.body{
      overflow: auto;
  }
    .content {
        width: 810px;
        margin: 10px auto;

        h2 {
            margin: 0 0 20px 0;
            text-align: center;
            width: 100%;
        }

        .hint-item {
            margin: 5px 0;

            .extra-hint {
                color: #ff0000;
            }
        }
    }

    .school-info-item {
        margin: 5px 0;
    }

    .school-info {
        margin: 20px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/promoteGrade.vue